import styled from 'styled-components';

export const StyledCreateMeetingPage = styled.div.attrs(props => ({
  className: props.className
}))`
  height: 100%;
  margin: 20px auto;
  padding: 40px;
  overflow-y: scroll;
`;